import Preloader from "components/Preloader/Preloader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components/macro";
import {
  fetchAccessory,
  selectAccessoryForEditing,
  setAccessoryOptions,
  updateAccessory,
  setAccessoryForEdit,
} from "../accessoriesAdminSlice";
import AccessoryForm from "./AccessoryForm";
import { createAccessoryObj } from "./utils";

const EditAccessory = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const fields = useSelector(selectAccessoryForEditing);
  useEffect(() => {
    dispatch(fetchAccessory(id));
    return () => {
      dispatch(setAccessoryForEdit(undefined));
    };
  }, [dispatch]);

  const onSubmit = (data: any) => {
    let obj = createAccessoryObj(data);

    const accessory = { id: id, data: obj };
    dispatch(
      updateAccessory(accessory, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return fields ? (
    <AccessoryForm formTitle="Промяна на аксесоар" onSubmit={onSubmit} fields={fields} progress={progress} />
  ) : (
    <LoaderWrapper>
      <Preloader />
    </LoaderWrapper>
  );
};
const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;
export default EditAccessory;
